import { action } from 'typesafe-actions'
import { ActiveSearchTypes, IPaginatorModified } from './types'
import { IAxiosResponse } from '../root.types'
import { PotentialPatient } from '../../application/models/potential.patient/potentialPatient'

export const resetPaginator = () => action(ActiveSearchTypes.RESET_PAGINATOR)

export const handleDialog = (dialog: boolean) => action(ActiveSearchTypes.HANDLE_DIALOG, { dialog })

export const storeActiveSearch = (activeSearch: PotentialPatient) => action(ActiveSearchTypes.STORE_ACTIVESEARCH, { activeSearch })

export const  handlePromoteRequest = (activeSearch: PotentialPatient) =>
    action(ActiveSearchTypes.HANDLE_PROMOTE_REQUEST, { activeSearch })

export const handlePromoteSuccess = (activeSearch: PotentialPatient) =>
    action(ActiveSearchTypes.HANDLE_PROMOTE_SUCCESS, { activeSearch })

export const handlePromoteFailure = () =>
    action(ActiveSearchTypes.HANDLE_PROMOTE_FAILURE)

// actions promover um potencial paciente para paciente
export const promoteActiveSearchRequest = (activeSearchId:string) =>
    action(ActiveSearchTypes.PROMOTE_ACTIVESEARCH_REQUEST, { activeSearchId })

export const promoteActiveSearchSuccess = (activeSearchId: string) =>
    action(ActiveSearchTypes.PROMOTE_ACTIVESEARCH_SUCCESS, { activeSearchId })

export const promoteActiveSearchFailure = () =>
    action(ActiveSearchTypes.PROMOTE_ACTIVESEARCH_FAILURE)

// actions rejetar um potencial paciente para paciente
export const rejectActiveSearchRequest = (activeSearchId: string) =>
    action(ActiveSearchTypes.REJECT_ACTIVESEARCH_REQUEST, { activeSearchId })

export const rejectActiveSearchSuccess = (activeSearchId: string) =>
    action(ActiveSearchTypes.REJECT_ACTIVESEARCH_SUCCESS, { activeSearchId })

export const rejectActiveSearchFailure = () =>
    action(ActiveSearchTypes.REJECT_ACTIVESEARCH_FAILURE)


// actions de captura de activeSearchas de um determinado dia
export const loadActiveSearchRequest = (paginator?: IPaginatorModified) =>
    action(ActiveSearchTypes.LOAD_ACTIVESEARCH_REQUEST, { paginator })

export const loadActiveSearchSuccess = (response: IAxiosResponse<PotentialPatient[]>

) => action(ActiveSearchTypes.LOAD_ACTIVESEARCH_SUCCESS, response)

export const loadActiveSearchFailure = () => action(ActiveSearchTypes.LOAD_ACTIVESEARCH_FAILURE)

// actions que procura um dado de activeSearch
export const findActiveSearchRequest = (activeSearchId: string

) => action(ActiveSearchTypes.FIND_ACTIVESEARCH_REQUEST, { activeSearchId })

export const findActiveSearchSuccess = (response: IAxiosResponse<PotentialPatient>

) => action(ActiveSearchTypes.FIND_ACTIVESEARCH_SUCCESS, response)

export const findActiveSearchFailure = () => action(ActiveSearchTypes.FIND_ACTIVESEARCH_FAILURE)

export const removeActiveSearchRequest = (activeSearchId: string

) => action(ActiveSearchTypes.REMOVE_ACTIVESEARCH_REQUEST, { activeSearchId })

export const removeActiveSearchSuccess = (activeSearchId: string

) => action(ActiveSearchTypes.REMOVE_ACTIVESEARCH_SUCCESS, { activeSearchId })

export const removeActiveSearchFailure = () => action(ActiveSearchTypes.REMOVE_ACTIVESEARCH_FAILURE)